export default {
      id: "products-menu-usage",
      viewBox: "0 0 35 35",
      url: "/dist/svg/" + "sprite.svg#products-menu-usage",
      toString: function () {
        return this.url;
      }
    }